// extracted by mini-css-extract-plugin
export default {"checkbox":"SelectQuestion_checkbox__LlcFP","option":"SelectQuestion_option__uSxrK","question":"SelectQuestion_question__tf5YH"};